<template>
  <div>
    <header
      :class="fixedNav ? 'header header-fixed' : 'header'"
      @mouseleave="mouseleave"
      @mouseover="mouseover"
    >
      <div class="el-row" style="height: 100%">
        <div
          class="height_100 el-col el-col-24 el-col-sm-17 el-col-md-15 el-col-md-offset-1 el-col-lg-12 el-col-lg-offset-3 el-col-xl-8 el-col-xl-offset-4"
        >
          <ul class="header_left clearfix height_100">
            <li class="logo">
              <img
                src="../../assets/newimg/logo.png"
                v-show="isShowBlackLogo"
              />
              <img
                src="../../assets/newimg/logo_w.png"
                v-show="!isShowBlackLogo"
              />
            </li>
            <li>
              <a
                href="/"
                :class="
                  myMenuIndex == 0
                    ? 'router-link-exact-active router-link-active'
                    : ''
                "
                >首页</a
              >
            </li>
            <li style="cursor: pointer">
              <a
                :class="
                  myMenuIndex == 1
                    ? 'router-link-exact-active router-link-active solution-menu'
                    : 'solution-menu'
                "
                >产品</a
              >
              <div class="solution-container">
                <div
                  v-for="(item, index) in productList"
                  :key="index"
                  class="solution-container-item"
                  @click="clickProductItem(item.url)"
                >
                  <div>{{ item.title }}</div>
                  <div>{{ item.content }}</div>
                </div>
              </div>
            </li>
            <li>
              <a
                href="/yantuai"
                :class="
                  myMenuIndex == 2
                    ? 'router-link-exact-active router-link-active'
                    : ''
                "
                >岩土AI</a
              >
            </li>
            <!-- <li style="cursor: pointer">
              <a
                :class="
                  myMenuIndex == 2
                    ? 'router-link-exact-active router-link-active solution-menu'
                    : 'solution-menu'
                "
                >解决方案</a
              >
              <div class="solution-container">
                <div
                  v-for="(item, index) in solutionList"
                  :key="index"
                  class="solution-container-item"
                  @click="clickProductItem(item.url)"
                >
                  <div>{{ item.title }}</div>
                  <div>{{ item.content }}</div>
                </div>
              </div>
            </li> -->

            <li>
              <a
                href="/about"
                :class="
                  myMenuIndex == 4
                    ? 'router-link-exact-active router-link-active'
                    : ''
                "
                >关于我们</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="workstation" @click="showTools">登录工作台</div>
      <!-- <img :src="iconImg" style="	position: fixed;
	width: 64px;
	height: 64px;
	border-radius: 50%;
	overflow: hidden;
	transition: all .4s ease-in-out;
	top: 6px;
	right: 20px;
	transform: translate(-50%, 0) rotate(0deg);
	cursor: pointer;" @click="showTools" /> -->
    </header>
    <div style="height:76px"></div>
    <header class="hidden-sm-and-up header_warp_m">
      <div class="header_m clearfix" v-bind:class="{ header_m_active }">
        <div class="header_logo">
          <img src="../../assets/newimg/logo.png" alt="" />
          <!---->
        </div>
        <div class="header_icon">
          <div
            class="header_icon_btn"
            v-bind:class="{ header_icon_btn1 }"
            @click="showCont"
          >
            <span></span> <span></span> <span></span>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import MyukiGCard from "../../utils/MyukiGCard.js";
var MyNavCard = null;
export default {
  props: {
    menuIndex: {
      type: Number,
      default: 0,
    },
    fixedNav: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      iconImg: require("@/assets/logo1.png"),
      show: false,
      header_icon_btn1: false,
      header_m_active: false,
      myMenuIndex: this.menuIndex,
      isShowBlackLogo: false,
      productList: [
        {
          title: "e勘察数字服务系统",
          content:
            "将勘察数据采集、数据存储与导出与后续勘察数据分析、整理与归档形成闭合，提高工作效率",
          url: "/ekancha",
        },
        {
          title: "岩土勘察数据分析（YTKC软件）",
          content:
            "进行概预算、工作量统计、土层统计、试验指标统计，计算土层沉降量、单桩承载力、黄土湿陷量、边坡安全系数等",
          url: "/ytkc",
        },
        {
          title: "岩土工程勘察文件自动化系统",
          content:
            "软件链接YTKC数据库，并自动生成GA数据库，用户录入项目工程信息，设置报告目录，即可一键生成勘察报告",
          url: "/automation",
        },
        {
          title: "大西安岩土与地质环境综合信息系统",
          content:
            "大西安地区有据可查的地质数据，并提供展示、提取、查询、研究和管理功能",
          url: "/geology",
        },
      ],
      solutionList: [
        {
          title: "工程行业解决方案",
          content:
            "自动化勘察业务流程，减少人力和时间成本，提高勘察效率，降低企业的勘察成本",
          url: "/gongcheng",
        },
      ],
    };
  },
  mounted() {
    if (this.myMenuIndex != 99) {
      window.addEventListener("scroll", this.getScroll);
    }

    if (this.fixedNav) {
      this.isShowBlackLogo = true;
    }

    
  },
  destroyed() {
    if (this.myMenuIndex != 99) {
      window.removeEventListener("scroll", this.getScroll);
    }
  },
  methods: {
    showTools(){
      window.open('https://www.ekc365.com/web/#/login?redirect=%2Findex','__blank')
  //   if (MyNavCard == null) {
  //   MyNavCard = $MGC({
  //     icon: this.iconImg,
  //     /*
  // icon: 可以是头像、网站logo等
  // */
  //     name: "everything is ok",
  //     /*
  // name: 可是是名字、网站名称等
  // */
  //     info: "欢迎使用e勘察",
  //     /*
  // info: 个性签名、网站口号、信息等，为空或者不设置将不显示
  // 默认值: 空
  // */
  //     z_index: 9999,
  //     /*
  // 不用解释，默认值为9999
  // */
  //     blur: "#write",
  //     /*
  // blur: 想要模糊化处理的页面元素，取值可以是.className（类名）、#idName（id属性值）、tagName（标签名）
  // */
  //     lang: "en-US",
  //     /*
  // lang: 语言设置，目前和关闭按钮的文本有关
  // 默认值: zh-CN
  // 可选值: zh-CN,zh-TW,en-US
  // 如果不提供或者提供的不在可选值内，将使用默认值或者使用html页面的lang属性
  // */
  //     mini: true,
  //     /*
  // mini: 迷你按钮，用于重新打开MyukiGCard（在页面底部中间位置）
  // 默认值: true
  // */
  //     darkmode: 2,
  //     /*
  // darkmode: 夜间模式
  // 默认值: 1
  // 可选值: 0、1、2、3
  // 0: 禁用夜间模式
  // 1: 跟随系统（如果系统支持夜间模式）
  // 2: 根据时间，下午6时～上午6时打开夜间模式
  // 3: 常开夜间模式
  // */
  //     maxWidth: "480px",
  //     /*
  // maxWidth: MyukiGCard的最大宽度
  // 默认值: 480px
  // */
  //     fontFamily: "",
  //     /*
  // fontFamily: 字体，为空或不设置将使用默认字体
  // */
  //     hitokoto: {
  //       enable: true,
  //       /*
  //   enable: 是否启用一言API
  //   默认值: false
  //   */
  //       cats: ["d", "i", "k"],
  //       /*
  //   cats: 句子类型，详见：https://developer.hitokoto.cn/sentence/#句子类型-参数
  //   默认值: []
  //   a: 动画, b: 漫画, c: 游戏, d: 文学, e: 原创, f: 网络, 
  //   g: 其他, h: 影视, i: 诗词, j: 网易, k: 哲学, i: 抖机灵
  //   */
  //       offline: "兰博基尼和法拉利能一样吗？分手！",
  //       /*
  //   offline: 一言API请求错误时用于替换的离线语句
  //   */
  //       color: "#70a1ff",
  //       /*
  //   color: 一言语句颜色
  //   默认值: #70a1ff
  //   */
  //     },
  //     links: [
  //       {
  //         title: "e勘察",
  //         url: "https://www.ekc365.com/web/#/login?redirect=%2Findex",
  //         type: "primary",
  //         target: "_blank",
  //       },
  //       {
  //         title: "探索未知",
  //         url: "https://www.ekcgpt.xyz/",
  //         target: "_blank",
  //       },
  //     ],
  //   });

  //  }
    },
    getScroll() {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (
        !!document.documentElement.scrollTop &&
        document.documentElement.scrollTop >= 200
      ) {
        this.isShowBlackLogo = true;
      } else {
        this.isShowBlackLogo = false;
      }
    },
    mouseleave() {
      if (!this.fixedNav) {
        this.isShowBlackLogo = true;
      }
    },
    mouseover() {
      if (!this.fixedNav) {
        this.isShowBlackLogo = true;
      }
    },
    clickProductItem(link) {
      this.$router.push(link);
    },
    showCont() {
      this.show = !this.show;
      this.header_icon_btn1 = !this.header_icon_btn1;
      this.header_m_active = !this.header_m_active;
    },
  },
};
</script>
<style scoped lang="scss">
* {
  box-sizing: content-box;
}
.height_100 {
  height: 100%;
}
.header_left {
  width: 100%;
}
.header_left > li {
  float: left;
  text-align: center;
  width: 120px;
}
.header_left .router-link-exact-active.router-link-active {
  color: #409EFF !important;
  transition: color 0.3s;
  border-bottom: 1px solid #409EFF;
}
.header:hover {
  background-color: #fff;
  transition: all 0.5s;
  border-bottom: 1px solid #dedede;
  .header_left > li > a {
    color: #000;
  }
}
.logo {
  margin-left: -100px;
  margin-right: 40px;
}
.logo > img {
  width: 72px;
  vertical-align: middle;
}
.header_left > li > a {
  display: inline-block;
  font-size: 16px;
  color: #000;
  transform: translate3d(-5px, 0, 0);
  transition: transform 0.5s, color 0.5s;
  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);
  width: 116px;
}
.header_left > li > a:hover {
  color: #409EFF !important;
  transition: color 0.3s;
}

a {
  color: #fff;
  text-decoration: none;
  /* -webkit-backface-visibility: hidden; */
}
.header {
  width: 100%;
  height: 76px;
  line-height: 76px;
  /* background-color: hsla(0, 0%, 100%, 0.95); */
  position: fixed;
  top: 0;
  z-index: 999;
}
.header_logo > img {
  width: 100%;
}
.header_m img {
  vertical-align: middle;
  line-height: 1.18rem;
  margin-top: 10px;
}
.header_m > .header_logo {
  float: left;
  margin-left: 1rem;
  width: 3rem;
  height: 100%;
}
.header_m {
  background: #fff;
  height: 2.5rem;
}
.header_m > .header_icon {
  float: right;
  height: 100%;
}
.header_icon_btn {
  margin-top: 0.7rem;
  margin-right: 1.4rem;
  width: 1.52rem;
  height: 100%;
  line-height: 0;
}
.header_icon_btn > span {
  display: inline-block;
  vertical-align: top;
  margin: 0.18rem 0;
  width: 100%;
  height: 2px;
  background-color: #000;
  transition: all 0.5s ease-in-out;
  transform-origin: left center;
}
.header_m_active {
  background: #000;
}
.header_icon_btn1 > span:first-child {
  transform: rotate(45deg);
  background-color: #fff;
}
.header_icon_btn1 > span:nth-last-child(2) {
  opacity: 0;
}
.header_icon_btn1 > span:last-child {
  transform: rotate(-45deg);
  background-color: #fff;
}

.solution-container {
  background-color: #fff;
  position: fixed;
  top: 77px;
  width: 100vw;
  height: 0;
  display: flex;
  flex-wrap: wrap;
  z-index: 99;
  padding-bottom: 0px;
  box-shadow: 0 2px 4px -3px #dedede;
  left: 0;
  overflow: hidden;
  &-item {
    width: 33%;
    background: #fff;
    :first-child {
      color: #000;
      margin-top: 30px;
      text-align: left;
      padding-left: 60px;
      font-size: 16px;
      cursor: pointer;
      line-height: 30px;
      font-weight: 600;
    }
    :first-child:hover {
      color: #409EFF;
      transition: color 0.3s;
    }
    :last-child {
      color: #666;
      margin-top: 10px;
      text-align: left;
      padding-left: 60px;
      font-size: 14px;
      line-height: 30px;
    }
  }
}
.solution-container:hover {
  height: 240px;
  padding-bottom: 40px;
  .header {
    background-color: #fff !important;
  }
}
.solution-menu:hover + .solution-container {
  height: 240px;
  padding-bottom: 40px;
  transition: all 0.5s;
}
.header-fixed {
  background-color: #fff;
  border-bottom: 1px solid #dedede;
  li > a {
    color: #000;
  }
}
.workstation {
  position: fixed;
    right: 40px;
    top: 0;
    cursor: pointer;
}
.workstation:hover{
  color: #409EFF;
  transition: all 0.3s;
}
</style>
<style>
.el-dropdown {
  font-size: 16px;
  color: #fff;
}
</style>
